import { ActivatedRouteSnapshot } from '@angular/router';

import { organizationDetailTokenizer } from '../store';

export const orgDetailResolver = (route: ActivatedRouteSnapshot) => {
  const store = organizationDetailTokenizer();
  const orgKey =
    route.paramMap.get('id') ?? route.parent?.paramMap.get('id') ?? '';

  if (!orgKey) {
    return false;
  }

  if (orgKey !== store.$organizationKey()) {
    store.resetStore();
    store.setOrganizationKey(orgKey);
    store.fetchOrganization();
    store.fetchOrganizationAddresses();
    store.fetchOrganizationMembers();
  }

  return true;
};
